/**
 * System Administration Component
 * Router component for system administration pages
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuditLog from './AuditLog';
import Settings from './Settings';

const SystemAdministration: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard/system/audit" replace />} />
      <Route path="/audit" element={<AuditLog />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<Navigate to="/dashboard/system/audit" replace />} />
    </Routes>
  );
};

export default SystemAdministration;